<template>
  <div class="page height-full">
    <md-dialog :md-active.sync="showDialog" class="md-dialog-container">
      <md-dialog-title>New User</md-dialog-title>
      <md-dialog-content class="dialog-content">
        <b-form-group
          id="input-group-1"
          label="First Name:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="form.name"
            type="text"
            required
            placeholder="First name"
          />
        </b-form-group>

        <b-form-group id="input-group-2" label="Last Name:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.familyName"
            required
            placeholder="Last name"
          />
        </b-form-group>

        <b-form-group id="input-group-4" label="Email:" label-for="input-4">
          <b-form-input
            id="input-4"
            v-model="form.email"
            required
            placeholder="Email"
          />
        </b-form-group>

        <b-form-group id="input-group-4" label="Role:" label-for="input-4">
          <b-form-select v-model="form.role" :options="options"></b-form-select>
        </b-form-group>

      </md-dialog-content>
      <md-dialog-actions>
        <md-button type="reset" class="md-primary" @click="close">Close</md-button>
        <md-button type="submit" class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showAdAccountDialog" class="md-dialog-container">
      <md-dialog-title>Attach Ad Account</md-dialog-title>
      <md-dialog-content class="dialog-content">
        <b-form-group label="Ad Account ID">
          <b-form-input
            v-model="adAccount.id"
            placeholder="Ad Account ID"
          />
        </b-form-group>
        <b-form-group label="Ad Account Name">
          <b-form-input
            v-model="adAccount.name"
            placeholder="Ad Account Name"
          />
        </b-form-group>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button type="reset" class="md-primary" @click="close">Close</md-button>
        <md-button type="submit" class="md-primary" @click="saveAdAccount">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
    <app-header :title="appTitle()"/>
    <b-card>
      <div>
        <b-button variant="primary" class="brand-purple compose-btn" @click="showDialog = true" style="float: right; margin-bottom: 16px;">
          Add Clients
        </b-button>
        <b-table hover :items="items" :fields="fields">
          <template v-slot:cell(actions)="data">
            <div class="action-container" v-if="isOwner(data) == false">
             <b-dropdown
               variant="link"
               size="lg"
               toggle-class="text-decoration-none"
               no-caret
               right
             >
               <template slot="button-content">
                 <b>⋮</b>
               </template>
               <b-dropdown-item class="delete" @click="deleteUser(data)"><b-icon-trash></b-icon-trash><span>Remove User</span></b-dropdown-item>
             </b-dropdown>
            </div>
          </template>
        </b-table>
        <spinner v-if="isLoading"></spinner>
      </div>
    </b-card>
    <b-card v-if="account !== null" class="mt-4">
      <h3>Content</h3>
      <b-btn variant="primary" class="brand-purple" :href="account.googleDriveUrl">Content Repository</b-btn>
    </b-card>
    <b-card class="mt-4" v-if="account !== null">
      <h3>Facebook Ad Accounts</h3>
      <!-- <b-button @click="facebookOauth">Connect Facebook</b-button> -->
      <b-table hover :items="account.adAccounts" :fields="adAccountFields">
        <template v-slot:cell(actions)="data">
          <div class="action-container">
           <b-dropdown
             variant="link"
             size="lg"
             toggle-class="text-decoration-none"
             no-caret
             right
           >
             <template slot="button-content">
               <b>⋮</b>
             </template>
             <b-dropdown-item class="delete" @click="deleteAdAccount(data)"><b-icon-trash></b-icon-trash><span>Remove Ad Account</span></b-dropdown-item>
           </b-dropdown>
          </div>
        </template>
      </b-table>
      <b-row class="pad-ad-id">
        <b-col md=3>
          <b-button variant="primary" class="brand-purple"  @click="attachAdAccount">Attach Ad Account</b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mt-4">
      <h3>Onboarding Status</h3>
      <b-list-group v-if="account !== null">
        <b-list-group-item v-if="account.signedContract == 1" class="d-flex justify-content-between align-items-center">
          <del>Sign Contract that was sent via email</del>
          <b-badge variant="success" pill><b-icon-check/></b-badge>
        </b-list-group-item>
        <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
          Sign Contract that was sent via email
        </b-list-group-item>

        <b-list-group-item v-if="account.paidSetupFee == 1" class="d-flex justify-content-between align-items-center">
          <del>Process payment for setup fee</del>
        </b-list-group-item>
        <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
          Process payment for setup fee
        </b-list-group-item>

        <b-list-group-item v-if="account.invitedPartnerFacebook == 1"class="d-flex justify-content-between align-items-center">
          <del>Invite Boom Media Partner ID to your Facebook Ad Account</del>
        </b-list-group-item>
        <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
          Invite Boom Media Partner ID to your Facebook Ad Account
        </b-list-group-item>

        <b-list-group-item v-if="account.uploadedDriveContent == 1" class="d-flex justify-content-between align-items-center">
          <del>Upload content to Google Drive</del>
        </b-list-group-item>
        <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
          Upload content to Google Drive
        </b-list-group-item>

        <b-list-group-item v-if="account.invitedTeam == 1" class="d-flex justify-content-between align-items-center">
          <del>Invite your team members</del>
        </b-list-group-item>
        <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
          Invite your team members
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>

  import Constants from '../../../Constants'
  import axios from 'axios'
  import Spinner from '../../common/Spinner'

  export default {
    name: "AdminAccountUsers",
    components: {
      Spinner
    },
    data: () => {
      return {
        items: [],
        isLoading: false,
        selectedUser: null,
        account: null,
        adAccount: {
          id: '',
          name: ''
        },
        adAccountFields: ['name', 'id', 'actions'],
        isSavingAdAccount: false,
        form: {
          name: '',
          ph: '',
          familyName: '',
          country: '',
          email: '',
          role: ''
        },
        fields: ['givenName', 'familyName', 'email', 'role', 'actions'],
        showDialog: false,
        showAdAccountDialog: false,
        showEditDialog: false,
        options: [
          { value: 'client', text: 'Client - View Data' }
        ]
      }
    },
    methods: {
      attachAdAccount() {
        this.showAdAccountDialog = true
      },
      facebookOauth() {
        const id = this.$route.params.id
        const redirectUri = 'https://dev.boommedia.agency/'
        window.location.href = "https://www.facebook.com/v2.2/dialog/oauth?client_id=2751376141655988&redirect_uri=" + redirectUri + "&scope=ads_read"
      },
      deleteAdAccount(data) {
        const adAccountId = data.item.id
        const id = this.$route.params.id
        axios.delete(Constants.API_URL + '/account/users/' + id + '/adAccounts/' + adAccountId)
          .then(response => {
            console.log(response)
            this.getAccount()
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      deleteUser(data) {
        this.isLoading = true
        const id = data.item.sk.split('|')[1]
        axios.delete(Constants.API_URL + '/account/users/' + id)
          .then(response => {
            this.getUsers()
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      saveAdAccount() {
        this.isSavingAdAccount = true
        const id = this.$route.params.id
        const data = {
          id: this.adAccount.id,
          name: this.adAccount.name
        }
        axios.post(Constants.API_URL + '/admin/accounts/' + id + '/adAccounts', data)
          .then(response => {
            console.log(response)
            this.close()
            swal('Ad Account Created', 'Successfully attached ad account.', 'success')
            this.getAccount()
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isSavingAdAccount = false
          })
      },
      appTitle() {
        if (this.account !== null) {
          return this.account.name + " Settings"
        } else {
          return "Account Settings"
        }
      },
      editUser: function(data) {
        console.log(data)
        this.selectedUser = data.item
        this.showEditDialog = true
      },
      updateRole: function(data) {
        const userId = this.selectedUser.sk.split('|')[1]
        this.isLoading = true
        axios.put(Constants.API_URL + "/account/users/" + userId, {role: this.form.role})
          .then((response) => {
            swal('Role Updated', 'Successfully updated user role to ' + this.form.role, 'success')
            this.close()
            this.getUsers()
          }).catch((err) => {
            swal('Error', 'Error Updating Role', 'error')
          }).then(() => {
            this.isLoading = false
          })
      },
      isOwner: function(data) {
        return data.item.role == "owner"
      },
      getUsers() {
        this.isLoading = true
        const id = this.$route.params.id
        axios
          .get(Constants.API_URL + "/admin/accounts/" + id + "/clients")
          .then(response => {
            console.log(response)
            this.items = response.data.Items
          }).catch((err) => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      reset() {
        this.form.country = "";
        this.form.name = "";
        this.form.ph = "";
        this.form.familyName = "";
      },
      close() {
        this.reset();
        this.showDialog = false
        this.showAdAccountDialog = false
      },
      save() {
        const params = {
          givenName: this.form.name,
          familyName: this.form.familyName,
          email: this.form.email,
          role: this.form.role
        }

        const id = this.$route.params.id

        console.log(params)
        this.isLoading = true
        axios
          .post(Constants.API_URL + '/admin/accounts/' + id + '/clients', params)
          .then(response => {
            console.log(response);
            this.close()
          }).catch((err) => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
            this.getUsers()
          })
      },
      getAccount() {
        const id = this.$route.params.id
        axios.get(Constants.API_URL + "/admin/accounts/" + id)
          .then(response => {
            console.log(response)
            this.account = response.data.Items[0]
            this.adAccountId = this.account.fbAdAcctId
          }).catch(err => {
            console.error(err)
          })
      }
    },
    mounted() {
      this.getAccount()
      this.getUsers()
    }
  }
</script>

<style scoped>
  .dialog-content {
    max-height: 600px;
    width: 500px;
  }

  .country-content {
    width: 100%;
  }

  .action-container {
    margin-top: -10px;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }

  .pad-ad-id {
    padding-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/accounts/AdminAccountUsers.vue